// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 80px;
}

.App-header {
  background-color: #222;
  height: 150px;
  padding: 20px;
  color: white;
}

.App-intro {
  font-size: large;
}

@keyframes App-logo-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

#root {

  box-sizing:border-box;
}

.page {
  width:100%;
  max-width:1100px;
  margin:auto;

}

.stretcher {
  min-height: 100vh;
  position: relative;
}


footer {
  position: absolute;
  bottom:0;
  width:100%;

}
/*  ClearFix  */
/*  The ClearFix by Tony Aslett and Nicholas Gallagher */
.group:before,
.group:after {
content: "";
display: table; }

.group:after {
clear: both; }

.group {
zoom: 1;
/* IE6&7 */ }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;;AAEb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;;AAEZ;AACA,eAAe;AACf,wDAAwD;AACxD;;AAEA,WAAW;AACX,cAAc,EAAE;;AAEhB;AACA,WAAW,EAAE;;AAEb;AACA,OAAO;AACP,UAAU,EAAE","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px;\n}\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white;\n}\n\n.App-intro {\n  font-size: large;\n}\n\n@keyframes App-logo-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n#root {\n\n  box-sizing:border-box;\n}\n\n.page {\n  width:100%;\n  max-width:1100px;\n  margin:auto;\n\n}\n\n.stretcher {\n  min-height: 100vh;\n  position: relative;\n}\n\n\nfooter {\n  position: absolute;\n  bottom:0;\n  width:100%;\n\n}\n/*  ClearFix  */\n/*  The ClearFix by Tony Aslett and Nicholas Gallagher */\n.group:before,\n.group:after {\ncontent: \"\";\ndisplay: table; }\n\n.group:after {\nclear: both; }\n\n.group {\nzoom: 1;\n/* IE6&7 */ }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
